function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "39954C99-4B73-42CE-B44F-D31B34B6C304");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M2,20.3333331 L2,20.3333334 C2,21.2538083 2.74619257,22 3.66666674,22 L20.3333334,22 L20.3333333,22 C21.2538083,22 22,21.2538083 22,20.3333334 L22,11.1666668 L2,11.1666668 L2,20.3333331 Z M20.3333334,3.66666665 L17.8333334,3.66666665 L17.8333334,2.83333332 L17.8333334,2.83333332 C17.8333334,2.37309583 17.4602376,2 17,2 C16.5397626,2 16.1666667,2.37309583 16.1666667,2.83333332 L16.1666667,3.66666665 L7.83333341,3.66666665 L7.83333341,2.83333332 L7.83333341,2.83333332 C7.83333341,2.37309583 7.46023757,2 7,2 C6.53976257,2 6.16666674,2.37309583 6.16666674,2.83333332 L6.16666674,3.66666665 L3.66666674,3.66666665 L3.66666667,3.66666665 C2.74619167,3.66666669 2,4.41285914 2,5.33333329 C2,5.33333329 2,5.33333329 2,5.33333329 L2,9.5 L22,9.5 L22,5.33333329 L22,5.33333329 C22,4.4128583 21.2538075,3.66666665 20.3333333,3.66666665 L20.3333334,3.66666665 Z M7.00000007,7.83333326 L7.00000004,7.83333326 C6.53976254,7.83333326 6.1666667,7.46023743 6.1666667,6.99999994 C6.1666667,6.53976244 6.53976254,6.16666661 7.00000004,6.16666661 C7.46023754,6.16666661 7.83333337,6.53976244 7.83333337,6.99999994 L7.83333337,6.9999999 C7.83333337,7.46023739 7.46023754,7.83333326 7.00000004,7.83333326 L7.00000007,7.83333326 Z M17.0000001,7.83333326 L17,7.83333326 C16.5397625,7.83333326 16.1666667,7.46023743 16.1666667,6.99999994 C16.1666667,6.53976244 16.5397625,6.16666661 17,6.16666661 C17.4602375,6.16666661 17.8333334,6.53976244 17.8333334,6.99999994 L17.8333334,6.9999999 C17.8333334,7.46023739 17.4602375,7.83333326 17,7.83333326 L17.0000001,7.83333326 Z",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Reporting",
  transform: "translate(-622.000000, -237.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Calendar/Calendar-Picker-Copy",
  transform: "translate(614.000000, 225.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(8.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "24pt-Bounding-Box",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Fill",
  fill: "#404F57",
  xlinkHref: "#path-1"
})))));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.15ec0386.svg";
export { ForwardRef as ReactComponent };